import { Component, inject } from '@angular/core';
import { BackendInterceptor, ProductListComponent, ProductListConfigService } from 'gung-standard';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'tylo-tylo-product-list',
    templateUrl: './tylo-product-list.component.html',
    styleUrls: ['./tylo-product-list.component.css'],
    standalone: false
})
export class TyloProductListComponent extends ProductListComponent {
  public override productListConfigService = inject(ProductListConfigService);
  public override route = inject(ActivatedRoute);
  protected override backendInterceptor = inject(BackendInterceptor);
}
